import React from 'react';
import './CTAsection.css';

const ContactSection = () => {
  return (
    <section className="cta-plain">
      <h2 className="cta-heading">Let’s Get In Touch.</h2>
      <p className="cta-subtext">
        Your laboratory instruments should serve you, not the other way around. We're happy to help you.
      </p>
      <div className="contact-buttons">
        <button className="contact-btn">Book a discovery call</button>
        <button className="contact-btn">Test Your Samples</button>
      </div>
    </section>
  );
};

export default ContactSection;
